module.exports = __webpack_public_path__ + "img/text.3beed328.png";